import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { OS_VERSION_VIDEO_REPORT_ID } from './osVersionVideoReportId';

const emptyColumns = [FIELDS.PLATFORM_CODE, FIELDS.OS_VERSION].map(createFooterMapper(OS_VERSION_VIDEO_REPORT_ID));

const osVersionReportFooterColumnDefinition = [...emptyColumns];

export default osVersionReportFooterColumnDefinition;
